import { Routes, Route, useLocation } from "react-router-dom"; // modified to include useLocation

import PublicLayout from "../layouts/PublicLayout/PublicLayout";
import AdminLayout from "../layouts/AdminLayout/AdminLayout";

import ProtectedRoute from "./ProtectedRout";

import Home from "../pages/PublicPages/Home/Home";
import Products from "../pages/PublicPages/ProductsPage/Products";
import CategoriesPage from "../pages/PublicPages/Home/Home/CategoriesSection/CategoriesPage"; // added
import PromotionsPage from "../pages/PublicPages/Home/Home/PromotionsSection/PromotionsPage"; // 
import BestSellersPage from "../pages/PublicPages/Home/Home/BestSellersSection/BestSellersPage"; // new
import NewArrivalsPage from "../pages/PublicPages/Home/Home/NewArrivalsSection/NewArrivalsPage"; // new
import TopRatedPage from "../pages/PublicPages/Home/Home/TopRatedSection/TopRatedPage"; // new
import PrivacyPolicyPage from "../pages/PublicPages/PrivacyPolicyPage";
import AboutUsPage from "../pages/PublicPages/AboutUsPage";
import ContactUsPage from "../pages/PublicPages/ContactUsPage";
import RefundAndShippingpolicy from "../pages/PublicPages/RefundAndShippingPolicy";



import Login from "../pages/Auth/Login";
import LoginSuccess from "../pages/Auth/LoginSuccess";
import Register from "../pages/Auth/RegisterPage";
import VerifyAccount from "../pages/Auth/VerifyAccount";
import ForgetPassword from "../pages/Auth/ForgetPassword";

import Dashboard from "../pages/AdminPages/DashboardPage";
import ProductsAndCategoryMainPage from "../pages/AdminPages/ProductsAndCategories/ProductsAndCategoriesMainPage"; // added
import CountriesPage from "../pages/AdminPages/CountriesPage/CountriesPage"; // added
import ShippingCompanyPage from "../pages/AdminPages/ShippingCompanyes/ShippingCompanyPage"; // added
import OrdersPage from "../pages/AdminPages/OrdersPage/OrdersPage"; // added
import AdvertisingBannersPage from "../pages/AdminPages/AdvertisingBannersPage/AdvertisingBannersPage"; // added
import ContactMessagesPage from "../pages/AdminPages/ContactMessages/ContactMessagesPage"; // added
import AdminAccountsPage from "../pages/AdminPages/AdminAccounts/AdminAccountsPage"; // added
import ClientsAccountsPage from "../pages/AdminPages/ClintsAccounts/ClintsAccountsPage"; // added
import ProductInfoPage from "../pages/PublicPages/ProductsPage/ProductInfo/ProductInfoPage"; // added

// clint
import SavedProductsPage from "../pages/PublicPages/Home/Home/SavedProducts"; // new component
import OrderPayment from "../pages/UserDashoard/MakeOrder/MakeOrderPage";
import OrderPaymentWaitingPage from "../pages/UserDashoard/MakeOrder/OrderPaymentWaitingPage";
import MyOrdersPage from "../pages/ClintDashboard/MyOrdersPage";

const AppRoutes = () => {
  // wrapper to pass initialEmail from location.state to ForgetPassword
  const ResetPasswordWrapper = () => {
    const location = useLocation();
    const initialEmail = location?.state?.email || "";
    return <ForgetPassword initialEmail={initialEmail} />;
  };

  return (
    <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/shop" element={<Products />} />
          <Route path="/promotions/:id" element={<PromotionsPage />} />
          <Route path="/category/:id" element={<CategoriesPage />} />
          <Route path="/product/:id" element={<ProductInfoPage />} />
          <Route path="/best-sellers" element={<BestSellersPage />} />
          <Route path="/new-arrivals" element={<NewArrivalsPage />} />
          <Route path="/top-rated" element={<TopRatedPage />} />
          <Route path="/saved-products" element={<SavedProductsPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/about-us" element={<AboutUsPage />} />
          <Route path="/contact-us" element={<ContactUsPage />} />
          <Route path="/refund-shipping-policy" element={<RefundAndShippingpolicy />} />
          <Route path="/login" element={<Login />} />
          <Route path="/login-success" element={<LoginSuccess />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify-account" element={<VerifyAccount />} />
          <Route path="/reset-password" element={<ResetPasswordWrapper />} />
          {/* must be logged in to access these routes: */}
          <Route path="/make-order" element={<ProtectedRoute allowed={["client", "user"]}><OrderPayment /></ProtectedRoute>} />
          <Route path="/order-payment" element={<ProtectedRoute allowed={["client", "user"]}><OrderPaymentWaitingPage /></ProtectedRoute>} />
          <Route path="/myorders" element={<ProtectedRoute allowed={["client", "user"]}><MyOrdersPage /></ProtectedRoute>} />          
        </Route>

       {/* ✅ Admin (Nested) */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute allowed={["admin"]}>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="products" element={<ProductsAndCategoryMainPage />} />
          <Route path="categories" element={<ProductsAndCategoryMainPage />} />
          <Route path="countries" element={<CountriesPage />} />
          <Route path="shipping-companies" element={<ShippingCompanyPage />} />
          <Route path="orders" element={<OrdersPage />} />
          <Route path="advertising-banners" element={<AdvertisingBannersPage />} />
          <Route path="contact-messages" element={<ContactMessagesPage />} />
          <Route path="admin-accounts" element={<AdminAccountsPage />} />
          <Route path="clients-accounts" element={<ClientsAccountsPage />} />
        </Route>

      {/* 404 */}
      <Route path="*" element={<h1>404 - Page Not Found</h1>} />
    </Routes>
  );
};

export default AppRoutes;
